var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kpisWrapper"},_vm._l((_vm.kpis),function(value,text){return _c('DashboardKPI',{key:(text + "_" + value),attrs:{"text":text,"value":value,"currency":_vm.currency}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }